import { useEffect, useRef, useState } from "react";
import BusinessSuiteContentLayout from "layout/business-suite-content/BusinessSuiteContentLayout";
import { FolderSync, CalendarCog } from "lucide-react";
import { StatusMsg } from "utils";
import { useAppSelector } from "store/store";
import { Snackbar } from "components";
import { ShimmerStaffRender } from "components/app/shrimmer/Shrimmer";
import { useDispatch } from "react-redux";
import { Sheet, SheetContent } from "components/ui/sheet";
import { useLocation } from "react-router-dom";
import { setOpenPopoverIndex } from "store/request";
import Status from "../Status";
import useUrlString from "../useUrlString";
import useRequestAction from "../request/RequestAction";
import RequestTypes from "../request/RequestTypes";
import RequestTable from "../request/RequestTable";
import RequestCard from "../request/RequestCard";
import RequestNavbar from "../request/RequestNavbar";
import PageLeavRequest from "./dialogPageRequest/PageLeavRequest";
export default function Request() {
  // *================Globle Store State===========
  const { openPopoverIndex } = useAppSelector((state) => state.request);
  const { btnSearchProduct } = useAppSelector((state) => state.header);

  const dispatch = useDispatch();
  // *================Function===========
  const location = useLocation();
  const handleClickCategory = ({ categoryName }: { categoryName: string }) => {
    if (selectedProductGroupCode === categoryName) return;
    setSelectedProductGroupCode(categoryName);
    selectedProductGroupCodeRef.current = categoryName;
  };
  const changeView = (selectedView: string) => {
    setView(selectedView);
    localStorage.setItem("leaveRequest-display-layout", selectedView);
  };
  const handleClickRequestTypes = (title: string) => {
    const validTitles = ["Leave Application Form", "Tardiness Application Form", "Change DO Application Form", "Change Shift Application Form"];

    if (validTitles.includes(title)) {
      dispatch(setOpenPopoverIndex(1));
      dataEmployeeRequest.getShopEmployeeInitRequest(title);
    } else {
      Snackbar({
        message: "Coming soon",
        status: StatusMsg.warning,
      });
    }
  };
  // *================Variable===========
  const { handleClickUrl, hanleClickRemoveURl } = useUrlString();
  const [isDetail, setIsDetail] = useState<boolean>(false);
  const dataEmployeeRequest = useRequestAction();
  const [selectedProductGroupCode, setSelectedProductGroupCode] = useState<string>("");
  const selectedProductGroupCodeRef = useRef(selectedProductGroupCode);
  const [selectProducts, setSelectProducts] = useState<boolean>(false);
  const [editItemCategories, setEditItemCategories] = useState<any>(null);
  const [selectedProductIds, setSelectedProductIds] = useState<string[]>([]);
  const [hovered, setHovered] = useState(false);
  const [view, setView] = useState("card");
  const listRef = useRef<any>(null);
  // *================Ueffect===========
  useEffect(() => {
    const savedView = localStorage.getItem("leaveRequest-display-layout");
    if (savedView) {
      setView(savedView);
    }
  }, [dataEmployeeRequest?.searchTextInput, selectedProductGroupCode]);

  const requestOption = [
    {
      id: 1,
      title: "Leave Application Form",
      label: "Please fill out the details of your leave request.",
      icon: (
        <div className="w-8 h-8 flex items-center justify-center bg-green-500 text-white p-2 rounded-full">
          <i className="fa-solid fa-person-walking-arrow-right fa-flip-horizontal"></i>
        </div>
      ),
      description: [],
    },

    {
      id: 2,
      title: "Tardiness Application Form",
      label: "Fill out this form to document your late attendance.",
      icon: (
        <div className="w-8 h-8 flex items-center justify-center bg-blue-500 text-white p-2 rounded-full">
          <i className="fa-solid fa-arrow-up-wide-short"></i>
        </div>
      ),
      description: [],
    },
    {
      id: 3,
      title: "Change DO Application Form",
      label: "Submit your request to modify your regular day off schedule.",
      icon: (
        <div className="w-8 h-8 flex items-center justify-center bg-cyan-500 text-white p-2 rounded-full">
          <CalendarCog />
        </div>
      ),
      description: [],
    },
    {
      id: 4,
      title: "Change Shift Application Form",
      label: "Request to modify assigned work shift schedule.",
      icon: (
        <div className="w-8 h-8 flex items-center justify-center bg-pink-500 text-white p-2 rounded-full">
          <FolderSync />
        </div>
      ),
      description: [],
    },
  ];
  useEffect(() => {
    dataEmployeeRequest?.getShopEmployeeRequestType();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (listRef.current && dataEmployeeRequest?.employeeRequestSearchLoading?.nextPageUrl && listRef.current.scrollHeight < window.innerHeight) {
      dataEmployeeRequest?.fetchMoreEmployeeRequestSearch({
        next: dataEmployeeRequest?.employeeRequestSearchLoading?.nextPageUrl,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataEmployeeRequest?.employeeInitRequestSearch?.data, dataEmployeeRequest?.searchTextInput, dataEmployeeRequest?.dobRequest]);

  useEffect(() => {
    dataEmployeeRequest?.getShopEmployeeRequestSearch(editItemCategories);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataEmployeeRequest?.searchTextInput, selectedProductGroupCode, dataEmployeeRequest?.dobRequest, dataEmployeeRequest?.btnToggle, btnSearchProduct]);

  useEffect(() => {
    const url = new URLSearchParams(location.search);
    const requestId: any = url.get("request_id");
    if (requestId) {
      (async () => {
        await dataEmployeeRequest?.getShopEmployeeRequestDetail(requestId);
        dataEmployeeRequest?.setWarning2(false);
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // =============Prop=============
  const requsetNavbarProp = {
    selectProducts: selectProducts,
    selectedProductIds: selectedProductIds,
    requestOption: requestOption,
    handleClickRequestTypes: handleClickRequestTypes,
    setIsDetail: setIsDetail,
    setWarning2: dataEmployeeRequest?.setWarning2,
    loadingPrint: dataEmployeeRequest?.loadingPrint,
    handlePrint: dataEmployeeRequest?.handlePrint,
    editItemCategories: editItemCategories,
    setDobRequest: dataEmployeeRequest?.setDobRequest,
    dobRequest: dataEmployeeRequest?.dobRequest,
    changeView: changeView,
    setSearchTextInput: dataEmployeeRequest?.setSearchTextInput,
    view: view,
  };
  const requestTypeProp = {
    hovered: hovered,
    setHovered: setHovered,
    setEditItemCategories: setEditItemCategories,
    selectedProductGroupCode: selectedProductGroupCode,
    handleClickCategory: handleClickCategory,
    loadingGetShopEmployeeRequestType: dataEmployeeRequest?.loadingGetShopEmployeeRequestType,
    mergedRequestTypes: dataEmployeeRequest?.mergedRequestTypes,
  };
  const requestCardProp = {
    listRef: listRef,
    selectProducts: selectProducts,
    setSelectedProductIds: setSelectedProductIds,
    selectedProductIds: selectedProductIds,
    handleClickUrl: handleClickUrl,
    employeeInitRequestSearch: dataEmployeeRequest?.employeeInitRequestSearch,
    fetchMoreEmployeeRequestSearch: dataEmployeeRequest?.fetchMoreEmployeeRequestSearch,
    employeeRequestSearchLoading: dataEmployeeRequest?.employeeRequestSearchLoading,
    getShopEmployeeRequestDetail: dataEmployeeRequest?.getShopEmployeeRequestDetail,
    setIsDetail: setIsDetail,
    setWarning2: dataEmployeeRequest?.setWarning2,
  };
  const requestTableProp = {
    listRef: listRef,
    selectProducts: selectProducts,
    setSelectedProductIds: setSelectedProductIds,
    selectedProductIds: selectedProductIds,
    handleClickUrl: handleClickUrl,
    employeeInitRequestSearch: dataEmployeeRequest?.employeeInitRequestSearch,
    fetchMoreEmployeeRequestSearch: dataEmployeeRequest?.fetchMoreEmployeeRequestSearch,
    employeeRequestSearchLoading: dataEmployeeRequest?.employeeRequestSearchLoading,
    getShopEmployeeRequestDetail: dataEmployeeRequest?.getShopEmployeeRequestDetail,
    setIsDetail: setIsDetail,
    setWarning2: dataEmployeeRequest?.setWarning2,
    loadingEmployeeInitRequestSearch: dataEmployeeRequest?.loadingEmployeeInitRequestSearch,
  };
  const pageLeaveRequestProp = {
    warning2: dataEmployeeRequest?.warning2,
    isDetail: isDetail,
    employeeInitRequest: dataEmployeeRequest.employeeInitRequest,
    loadingSubmitEmployeeInitRequest: dataEmployeeRequest?.loadingSubmitEmployeeInitRequest,
    leaveApplicationFrom: dataEmployeeRequest?.leaveApplicationFrom,
    setLeaveApplicationFrom: dataEmployeeRequest?.setLeaveApplicationFrom,
    tardinessApplicationFrom: dataEmployeeRequest?.tardinessApplicationFrom,
    setTardinessApplicationFrom: dataEmployeeRequest?.setTardinessApplicationFrom,
    changeDoApplicationFrom: dataEmployeeRequest?.changeDoApplicationFrom,
    setChangeDoApplicationFrom: dataEmployeeRequest?.setChangeDoApplicationFrom,
    changeShiftApplication: dataEmployeeRequest?.changeShiftApplication,
    setChangeShiftApplication: dataEmployeeRequest?.setChangeShiftApplication,
    handleSaveLeaveApplicationFrom: dataEmployeeRequest?.handleSaveLeaveApplicationFrom,
    handleSaveTardinessApplicationFrom: dataEmployeeRequest?.handleSaveTardinessApplicationFrom,
    handleSaveChangeDOApplicationFrom: dataEmployeeRequest?.handleSaveChangeDOApplicationFrom,
    handleSaveChangeShifApplicationFrom: dataEmployeeRequest?.handleSaveChangeShifApplicationFrom,
    loadingEmployeeInitRequestSearchDatail: dataEmployeeRequest?.loadingEmployeeInitRequestSearchDatail,
    loadingEmployeeInitRequest: dataEmployeeRequest?.loadingEmployeeInitRequest,
    setEmployeeInitRequest: dataEmployeeRequest?.setEmployeeInitRequest,
    getShopEmployeeRequestCommittee: dataEmployeeRequest?.getShopEmployeeRequestCommittee,
    shopEmployeeRequestCommittee: dataEmployeeRequest?.shopEmployeeRequestCommittee,
    setShopEmployeeRequestCommittee: dataEmployeeRequest?.setShopEmployeeRequestCommittee,
    handleAddApprover: dataEmployeeRequest?.handleAddApprover,
    handleScrollCommittee: dataEmployeeRequest?.handleScrollCommittee,
    scrollContainerRef: dataEmployeeRequest?.scrollContainerRef,
    warning: dataEmployeeRequest?.warning,
    errorStatus: dataEmployeeRequest?.errorStatus,
    isAddApproverLoading: dataEmployeeRequest?.isAddApproverLoading,
    submitShopEmployeeRequestUpdateStatus: dataEmployeeRequest?.submitShopEmployeeRequestUpdateStatus,
    submitShopEmployeeRequestUpdateStatusLoading: dataEmployeeRequest?.submitShopEmployeeRequestUpdateStatusLoading,
  };
  return (
    <BusinessSuiteContentLayout>
      {/* top bar */}
      <div className=" max-w-full z-50 w-auto bg-white  dark:bg-[#020817]">
        <div className="flex lg:flex-row md:flex-row flex-col justify-between left-0 items-center mb-3 w-full ">
          <div className="text-start lg:w-auto md:w-auto  w-full">
            <h1 className="font-semibold lg:text-lg md:text-md sm:text-sm">Request</h1>
            <p className=" whitespace-nowrap text-muted-foreground lg:text-md md:text-sm text-[13px]">Smart Scheduling, Attendance, and Performance Tracking</p>
          </div>
          {dataEmployeeRequest?.warning ? "" : <RequestNavbar {...requsetNavbarProp} />}
        </div>

        {dataEmployeeRequest?.warning ? "" : <RequestTypes {...requestTypeProp} />}
      </div>
      {dataEmployeeRequest?.warning ? (
        <Status errorStatus={dataEmployeeRequest?.errorStatus} className="h-[70vh]" />
      ) : (
        <div className="pb-3 h-full mt-5 ">
          {view === "card" ? (
            <>
              {dataEmployeeRequest?.loadingEmployeeInitRequestSearch ? (
                <>
                  <ShimmerStaffRender />
                </>
              ) : (
                <RequestCard {...requestCardProp} />
              )}
            </>
          ) : (
            <>{dataEmployeeRequest?.employeeInitRequestSearch ? <RequestTable {...requestTableProp} /> : <></>}</>
          )}
        </div>
      )}
      <Sheet
        open={openPopoverIndex === 1}
        onOpenChange={(isOpen) => {
          dispatch(setOpenPopoverIndex(isOpen ? 1 : null));
          if (!isOpen) {
            hanleClickRemoveURl("request_id");
          }
        }}
      >
        <SheetContent className="flex flex-col h-full sm:max-w-[1200px] justify-between p-3 pt-[50px]">
          <PageLeavRequest {...pageLeaveRequestProp} />
        </SheetContent>
      </Sheet>
    </BusinessSuiteContentLayout>
  );
}
